import React from 'react';

import Globals, { URLS } from '../../../utility/constants/appConstants';
import { amountFormatter }  from '../../../utility/utils/formatter';
import { Link } from 'react-router';

const Onetime = (props) => {
    const arBalance = props.arBalance;
    const {amountDue, payNow } = props.labels;
    let amount = arBalance>0 ?  arBalance : 0 ;
    const {dollars,cents} = amountFormatter(amount);

    const {paymentsCss, isActionEnabled} = props;

    return(
      <>
        <div className={`${paymentsCss["bg-white"]} col-12 col-md-4 col-lg-3 d-flex flex-column justify-content-end p-0 ${paymentsCss["tru-mma-main-side"]}`}>
          <div className={`align-items-center d-flex flex-column flex-fill justify-content-center ${paymentsCss["p-10"]} ${paymentsCss["glh-1_2"]}`}>
            <span className={`d-block ${paymentsCss["gfs-14"]} ${paymentsCss["gfs-lg-16"]} ${paymentsCss["gfw-3"]}`}>{amountDue}</span>
            <span className={`d-block ${paymentsCss["gfs-50"]} ${paymentsCss["gfs-md-26"]} ${paymentsCss["gfw-7"]}`}>
              <span className={`${paymentsCss["gfs-48"]}`}>{Globals.currencySymbol}{dollars}</span>
              <sup className={`${paymentsCss["gfs-26"]} tg-ml-2`}>{cents}</sup>
            </span>
          </div>
          {arBalance>0  && <Link 
            to={isActionEnabled?URLS.oneTime:""} 
            className={`ShowLoadingModal ${paymentsCss["bg-yellow"]} ${paymentsCss["gfs-20"]} gfs-md-10 ${paymentsCss["gfs-lg-20"]} text-center ${paymentsCss["tru-mma-main-side-update"]} ${!isActionEnabled ? 'opacity-50 pe-none' : ''}`}
            style={{fontSize: '20px'}}
            >
              {payNow}
            </Link>}
        </div>
      </>
    );
}

export default Onetime;